<script setup lang="ts">
const emit = defineEmits<{
  (event: 'click', payload: MouseEvent): void
}>()

defineProps<{
  thumbnailUrl?: string
  videoCount?: number
  name?: string
}>()
</script>

<template>
  <figure class="public-video-playlist d-flex flex-column">
    <a
      class="public-video-playlist__card"
      :style="{ backgroundImage: `url(${thumbnailUrl})` }"
      aria-label="Посмотреть все видео"
      @click="e => emit('click', e as MouseEvent)"
    >
      <div class="public-video-playlist__card-hover" aria-hidden>
        <v-icon size="40">mdi-play</v-icon>
        <span class="ml-1">Посмотреть все</span>
      </div>

      <div class="public-video-playlist__card-info">
        <span class="mb-1">{{ videoCount }} видео</span>
        <v-icon size="40">mdi-playlist-play</v-icon>
      </div>
    </a>

    <figcaption class="mt-2 text-body-bold" v-text="name" />
  </figure>
</template>

<style lang="scss">
$mobileMaxWidth: 960px;

.public-video-playlist {
  display: flex;
  flex-direction: column;

  @include desktop {
    flex: 0 0 376px;
  }

  @include mobile {
    width: min(100%, 376px);
  }

  &__card {
    display: block;
    background-color: $gray;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    width: 100%;
    height: 200px;
    border-radius: 8px;

    position: relative;
  }

  &__card-info {
    width: 130px;
    height: 100%;

    background: $black;
    opacity: 0.7;
    float: right;
    border-radius: 0 8px 8px 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: white;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
  }

  &__card:hover > &__card-hover {
    opacity: 1;
  }

  &__card-hover {
    background: rgba($black, 0.7);

    opacity: 0;
    transition: opacity 0.1s ease;

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    color: white;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;

    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
